"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var TournamentBlock = function (_a) {
    var _b, _c;
    var closeDigest = _a.closeDigest, tournament = __rest(_a, ["closeDigest"]);
    var t = (0, next_intl_1.useTranslations)('translation');
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var _d = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _d.joinTournament, isSubmitting = _d.isSubmitting;
    var participate = (0, react_1.useCallback)(function (id) {
        if (id)
            joinTournament({ id: id });
    }, [joinTournament]);
    var router = (0, navigation_1.useRouter)();
    var prizeToShow = (0, swr_hooks_1.useTournamentPrizes)(tournament);
    var onClickViewRating = (0, react_1.useCallback)(function () {
        var _a, _b;
        if ((_a = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.slug) {
            closeDigest();
            router.push(generateUrlWithLang("/tournaments/".concat((_b = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _b === void 0 ? void 0 : _b.slug)));
        }
    }, [
        closeDigest,
        generateUrlWithLang,
        router,
        (_b = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _b === void 0 ? void 0 : _b.slug,
    ]);
    if (!(tournament === null || tournament === void 0 ? void 0 : tournament.id))
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(!!(tournament === null || tournament === void 0 ? void 0 : tournament.me) ? styles_module_scss_1.default.participate : '') },
        !!(tournament === null || tournament === void 0 ? void 0 : tournament.me) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.participateLabel },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.check }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, (_c = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _c === void 0 ? void 0 : _c.name),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.poolPrize }, prizeToShow),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper }, !!(tournament === null || tournament === void 0 ? void 0 : tournament.me) ? (react_1.default.createElement(ui_components_1.GradientOutlinedButton, { onClick: onClickViewRating }, t('rating'))) : (react_1.default.createElement(ui_components_1.FixedButton, { text: "upper", color: "gradient", width: "200px", loading: isSubmitting, onClick: function () { return participate(tournament === null || tournament === void 0 ? void 0 : tournament.id); } }, t('joinNow')))))));
};
exports.default = TournamentBlock;
